import type { ReactNode } from "react";
import { BoardCardItemIdContext } from "./boardCardExpansion";
import { BoardCardKeyContext, BoardRovingContext } from "./boardRoving";

/**
 * A copy of the card at `placementKey` drawn outside its list, such as the
 * drag overlay: it shows the card's selection and drawer but stays out of the
 * roving Tab stop, so it never takes focus.
 */
export const BoardOverlayCard = ({
    itemId,
    placementKey,
    children,
}: {
    itemId: string;
    placementKey: string;
    children: ReactNode;
}) => (
    <BoardRovingContext.Provider value={null}>
        <BoardCardItemIdContext.Provider value={itemId}>
            <BoardCardKeyContext.Provider value={placementKey}>
                {children}
            </BoardCardKeyContext.Provider>
        </BoardCardItemIdContext.Provider>
    </BoardRovingContext.Provider>
);
